import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnnouncementPopup from '../../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import CompleteForm from './CompleteForm/CompleteForm';

import { REDIRECT_SUFFIX } from '../../../../framework/App/AppConstants';
import { connect } from 'react-redux';
import _ from 'lodash';
import './CompletePopup.less';
import RedirectButton from '../../../../shared-components/RedirectButton/RedirectButton';

const LOCALE_PREFIX = 'GB/pages/CAPage/CompletePopup';

export class CompletePopup extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        wallet: PropTypes.array,
        showMarketingConsent: PropTypes.bool
    };

    render() {
        const {
            intl,
            wallet,
            showMarketingConsent
        } = this.props;

        const footer = '';
        const showDirectDebit = !_.isEmpty(wallet);

        const redirectButton = (
            <RedirectButton
                ctaLabel={intl.formatMessage({ id: `${LOCALE_PREFIX}.controlContinue` })}
                className="paypalSuccessConsent"
                buttonId="paypalSuccessConsentSubmit"
                actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
            />);

        let announcementContent;

        if (showDirectDebit || showMarketingConsent) {
            announcementContent = (<div>
                <div>
                    <h3 className="vx_text-3">
                        <FormattedMessage id={`${LOCALE_PREFIX}.successHeader`} />
                    </h3>
                    <p>
                        <FormattedMessage id={`${LOCALE_PREFIX}.successText`} />
                    </p>
                </div>
                <CompleteForm
                    redirectButton={redirectButton}
                    showMarketingConsent={showMarketingConsent}
                    showDirectDebit={showDirectDebit}
                />
            </div>);
        } else {
            announcementContent = (
                <div>
                    <h3 className="vx_text-3">
                        <FormattedMessage id={`${LOCALE_PREFIX}.successHeader`} />
                    </h3>
                    <p>
                        <FormattedMessage id={`${LOCALE_PREFIX}.successText1`} />
                    </p>
                    <p>
                        <FormattedMessage id={`${LOCALE_PREFIX}.successText2`} />
                    </p>
                    {redirectButton}
                </div>
            );
        }

        return (
            <AnnouncementPopup
                footer={footer}
                id="CompletePopup"
                showXButton={false}
                stickyFooter={false}
            >
                { announcementContent }
            </AnnouncementPopup>
        );
    }
}

export const mapStateToProps = state => ({
    showMarketingConsent : _.get(state, 'serverData.showMarketingConsent'),
    wallet: _.get(state, 'serverData.wallet')
});

export default connect(mapStateToProps)(injectIntl(CompletePopup));
